export default (function (value) {
  return value;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/identity.js
// module id = 372
// module chunks = 0